var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PipePermissionChange_1;
import { JSON, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { pipePermissionChangeSchemaValidation } from '../validations.generated';
export var PipePermissionChangeType;
(function (PipePermissionChangeType) {
    PipePermissionChangeType["SET_PUBLIC"] = "set_public";
    PipePermissionChangeType["SET_PRIVATE"] = "set_private";
    PipePermissionChangeType["ADD_EDITOR"] = "add_editor";
    PipePermissionChangeType["REMOVE_EDITOR"] = "remove_editor";
})(PipePermissionChangeType || (PipePermissionChangeType = {}));
export const pipePermissionChangeSchema = {
    $id: 'urn:wisepipe-base-pipe:PipePermissionChange',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        pipeID: { type: 'string', uid: 10 },
        pipePermissionChangeType: { type: 'string', enum: Object.values(PipePermissionChangeType) },
        userIDs: { type: 'array', items: { type: 'string', format: 'uuid' } }
    },
    required: ['orgID', 'pipeID', 'pipePermissionChangeType'],
    if: {
        properties: {
            pipePermissionChangeType: {
                enum: [PipePermissionChangeType.ADD_EDITOR, PipePermissionChangeType.REMOVE_EDITOR]
            }
        }
    },
    then: {
        required: ['userIDs']
    }
};
let PipePermissionChange = PipePermissionChange_1 = class PipePermissionChange {
    constructor(orgID, pipeID, pipePermissionChangeType, userIDs) {
        this.orgID = orgID;
        this.pipeID = pipeID;
        this.pipePermissionChangeType = pipePermissionChangeType;
        if (userIDs)
            this.userIDs = userIDs;
        JSON.validate(this, PipePermissionChange_1);
    }
};
PipePermissionChange = PipePermissionChange_1 = __decorate([
    JsonSchemaV2(pipePermissionChangeSchema, pipePermissionChangeSchemaValidation)
], PipePermissionChange);
export { PipePermissionChange };
//# sourceMappingURL=pipePermissionChange.js.map